import { useTheme } from "@mui/material/styles";

import jobylonLogo from "../assets/images/jobylon-logo.png";
import jobylonLogoDark from "../assets/images/jobylon-logo-dark.png";
import type { Mode } from "../components/theme";

/**
 * Jobylon's wordmark per theme mode. The vendor's lettering is dark grey, which
 * vanishes on a dark surface, so the dark copy is the same file with only the
 * grey lettering made near-white; the blue mark is untouched.
 */
export const JOBYLON_LOGO: Record<Mode, string> = {
	light: jobylonLogo,
	dark: jobylonLogoDark,
};

/** The Jobylon wordmark that reads on the current theme's background. */
export const useJobylonLogo = (): string => JOBYLON_LOGO[useTheme().palette.mode];
